// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2oBNQ","container":"styles_container__3yY7k","title":"styles_title__3U3YJ","wrapper":"styles_wrapper__3o-BJ","answer":"styles_answer__3epqZ"};